export const VALUE_FORMATS = {
  // Percentages sometimes have the % symbol included depending on the renderer,
  // so they aren't strictly a number format.
  PERCENT: "percent",
  // Our percentages are provided by the API as a value between 0 - 1, but
  // we sometimes multiply this by 100 to display percentages between 0 - 100 in the application.
  // However, we don't want to multiply by 100 again for the download format.
  PERCENT_100: "percent100",
  NUMBER: "number",
  STRING: "string",
  CURRENCY: "currency",
}

export const ASSET_METRIC_IDS = [
  "marketValue",
  "percentEquity",
  "totalReturn",
  "specificReturn",
  "factorsReturn",
  "tradingReturn",
  "riskTotalContribution",
  "riskSpecificContribution",
  "riskFactorsContribution",
  "predictedBeta",
  "historicalBeta",
  "dynamicPredictedBeta",
]

export const METRICS = {
  PERFORMANCE: "performance",
  RISK: "risk",
  EXPOSURE: "exposure",
  BETA: "beta",
}

export const FACTOR_VIEWS = {
  ALL: "op_all",
}

export const METRIC_TYPES = {
  NET_CONTRIBUTION: "netContribution",
  Z_SCORE: "assetZScore",
  CURRENCY_EXPOSURE: "currencyExposure",
  CURRENCY_PERFORMANCE: "currencyPerformance",
  RISK_DECOMPOSITION: "riskDecomposition",
  STANDALONE: "standalone",
  CUMULATIVE_PERCENT: "cumulativePercent",
}

export const RESIDUAL_RETURN = "residualReturn"

export const INTRADAY_METRIC_CATEGORY = {
  id: "intraday",
  label: "Intraday",
  items: [
    {
      id: "prices",
      label: "Price",
      category: "Intraday",
      dataPath: "intraday.price",
      format: VALUE_FORMATS.CURRENCY,
      singleFactor: true,
    },
    {
      id: "percentChange",
      label: "% Price Change",
      category: "Intraday",
      dataPath: "intraday.change_percent",
      format: VALUE_FORMATS.PERCENT_100,
      singleFactor: true,
    },
    {
      id: "standaloneReturn1d",
      label: "1D Return (%)",
      category: "Intraday",
      dataPath: "intradayStandalone1d.returnPercent",
      format: VALUE_FORMATS.PERCENT,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 1D",
    },
    {
      id: "currencyStandalonePerformance1d",
      label: "1D Return ($)",
      category: "Intraday",
      dataPath: "intradayStandalone1d.currencyPerformance",
      format: VALUE_FORMATS.CURRENCY,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 1D",
    },
    {
      id: "standaloneReturn5d",
      label: "5D Return (%)",
      category: "Intraday",
      dataPath: "intradayStandalone5d.returnPercent",
      format: VALUE_FORMATS.PERCENT,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 5D",
    },
    {
      id: "currencyStandalonePerformance5d",
      label: "5D Return ($)",
      category: "Intraday",
      dataPath: "intradayStandalone5d.currencyPerformance",
      format: VALUE_FORMATS.CURRENCY,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 5D",
    },
    {
      id: "standaloneReturn1m",
      label: "1M Return (%)",
      category: "Intraday",
      dataPath: "intradayStandalone1m.returnPercent",
      format: VALUE_FORMATS.PERCENT,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 1M",
    },
    {
      id: "currencyStandalonePerformance1m",
      label: "1M Return ($)",
      category: "Intraday",
      dataPath: "intradayStandalone1m.currencyPerformance",
      format: VALUE_FORMATS.CURRENCY,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance 1M",
    },
    {
      id: "standaloneReturnMtd",
      label: "MTD Return (%)",
      category: "Intraday",
      dataPath: "intradayStandaloneMtd.returnPercent",
      format: VALUE_FORMATS.PERCENT,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance MTD",
    },
    {
      id: "currencyStandalonePerformanceMtd",
      label: "MTD Return ($)",
      category: "Intraday",
      dataPath: "intradayStandaloneMtd.currencyPerformance",
      format: VALUE_FORMATS.CURRENCY,
      singleFactor: true,
      tooltipMetricType: "Intraday Standalone Performance MTD",
    },
  ],
}
